import type { Element } from "React";
import "./IconPositionMatrix.scss";
type Props = {
  className?: string;
};

const IconPositionMatrix = (props: Props): Element<"div"> => (
  <div className="position-matrix-icon">
    <div className="position-matrix-icon__cell" />
    <div className="position-matrix-icon__cell" />
    <div className="position-matrix-icon__cell" />
    <div className="position-matrix-icon__cell" />
    <div className="position-matrix-icon__cell" />
    <div className="position-matrix-icon__cell" />
  </div>
);

export default IconPositionMatrix;
